// i18n area 'auth' — locale fr-FR (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.fr-FR.meta.json.
import type { enUS } from './auth'

export const frFR: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Connectez-vous à votre compte',
    username: "Nom d'utilisateur",
    usernamePlaceholder: "Saisissez votre nom d'utilisateur",
    usernameHint: 'Utilisez utilisateur@domaine pour vous authentifier sur un realm directory',
    continue: 'Continuer',
    changeUser: "Ce n'est pas vous ?",
    password: 'Mot de passe',
    forgotPassword: 'Mot de passe oublié ?',
    submit: 'Se connecter',
    otp: 'Code à usage unique',
    otpSubtitle: 'Saisissez le code de votre authentificateur',
    otpHint: "Six chiffres de votre app d'authentification, ou l'un de vos codes de récupération",
    otpSubmit: 'Vérifier',
    invalidCredentials: "Nom d'utilisateur ou mot de passe invalide",
    tooManyAttempts: 'Trop de tentatives — patientez un moment et réessayez',
    realmUnavailable: "Le realm ne peut pas vérifier les identifiants pour le moment — le store du cluster n'est pas joignable. Connectez-vous comme utilisateur local (break-glass).",
    genericError: 'La connexion a échoué — le backend TVirt est-il joignable ?'
  },
  user: {
    logout: 'Se déconnecter',
    password: {
      menu: 'Changer le mot de passe',
      title: 'Changer votre mot de passe',
      current: 'Mot de passe actuel',
      new: 'Nouveau mot de passe',
      confirm: 'Confirmer le nouveau mot de passe',
      mismatch: 'Les mots de passe ne correspondent pas',
      error: 'Impossible de changer le mot de passe',
      forcedTitle: 'Changez le mot de passe pour continuer',
      forcedHint: "Ce mot de passe a été défini par un administrateur et doit être remplacé avant d'entrer.",
      forcedSubmit: 'Changer et entrer'
    },
    mfa: {
      title: 'Authentification à deux facteurs',
      subtitle: 'Un second facteur demandé à chaque connexion',
      loadError: "Impossible de charger l'état du second facteur",
      enrolled: 'Actif',
      notEnrolled: 'Non actif',
      enrolledAt: 'Activé le',
      codesRemaining: 'Codes de récupération restants',
      requiredHint: "Un administrateur exige le second facteur sur ce compte : configurez-le maintenant — tant que ce n'est pas fait, vous pouvez vous connecter, mais guère plus.",
      enroll: 'Configurer',
      enrollTitle: "Configurer l'authentification à deux facteurs",
      enrollHint: "Scannez ce code avec l'app d'authentification, puis saisissez le code qu'elle affiche pour confirmer.",
      secretHint: "Impossible de le scanner ? Saisissez ce secret dans l'app :",
      code: "Code de l'app",
      confirm: 'Confirmer',
      startError: 'Impossible de démarrer la configuration',
      confirmError: 'Impossible de confirmer la configuration',
      codesTitle: 'Vos codes de récupération',
      codesWarning: "Ces codes ne sont affichés qu'une seule fois. Enregistrez-les maintenant : chacun vous connecte quand l'authentificateur n'est pas disponible, et ne vaut qu'une fois.",
      codesAck: "J'ai enregistré mes codes de récupération",
      codesDone: 'Terminé',
      copy: 'Copier',
      copied: 'Copié',
      download: 'Télécharger',
      regenerate: 'Nouveaux codes de récupération',
      regenerateTitle: 'Régénérer les codes de récupération',
      regenerateHint: "Tous les codes émis jusqu'ici cessent de fonctionner au moment où le nouveau jeu est généré.",
      regenerateConfirm: 'Régénérer',
      regenerateError: 'Impossible de régénérer les codes de récupération',
      remove: 'Retirer',
      removeTitle: 'Retirer le second facteur',
      removeConfirm: 'Retirer',
      removeHint: 'Le compte revient au mot de passe seul. Vous pouvez reconfigurer le second facteur quand vous voulez.',
      removeRequiredHint:
        "Un administrateur exige le second facteur sur ce compte, le serveur refusera donc de le retirer — demandez d'abord la levée de l'obligation.",
      removeError: 'Impossible de retirer le second facteur'
    },
    profile: {
      menu: 'Aller à mon profil',
      sessions: 'Sessions actives',
      sessionsHint: 'Vos sessions ouvertes sur ce nœud',
      sessionsEmpty: 'Aucune session active',
      sessionCreated: 'Connexion effectuée',
      sessionExpires: 'Expire',
      revoke: 'Révoquer la session',
      revokeError: 'Impossible de révoquer la session',
      loadError: 'Impossible de charger les sessions'
    }
  }
}
